import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Slide } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { TransitionProps } from '@mui/material/transitions';
import { useTranslation } from 'react-i18next';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ConfirmationDialog = ({ isOpen, setIsOpen, itemId, onConfirm, title, description, secureTime }: any) => {
  const [seconds, setSeconds] = useState(secureTime || false);
  const { t } = useTranslation<'translation'>();

  const handleAgree = () => {
    setIsOpen(false);
    if (itemId) {
      onConfirm(itemId);
    } else {
      onConfirm();
    }
  };

  useEffect(() => {
    if (seconds > 0) {
      const timerId = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
      return () => clearInterval(timerId);
    }
  }, [seconds]);

  return (
    <Dialog sx={{ zIndex: '1300' }} open={isOpen} TransitionComponent={Transition} keepMounted onClose={() => setIsOpen(false)} aria-describedby="alert-dialog-slide-description">
      <DialogTitle>{t(title) || 'Confirmation'}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t(description)}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <Button onClick={() => setIsOpen(false)} sx={{ marginRight: 2 }}>
          {t('Cancel')}
        </Button>
        <Button disabled={seconds > 0} variant="contained" onClick={() => handleAgree()} color={['delete'].some((word) => description.includes(word)) ? 'error' : 'primary'}>
          {seconds > 0 ? `${t('Yes')} (${seconds})` : t('Yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
